import { Button, Group, Modal, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
interface manageSubscriptionProps {
  openedModal: boolean;
  setOpenedModal: (value: boolean) => void;
}
const ManageSubscriptionDialog = ({
  setOpenedModal,
  openedModal
}: manageSubscriptionProps) => {
  const navigate = useNavigate();
  return (
    <Modal
      opened={openedModal}
      onClose={() => setOpenedModal(false)}
      closeOnClickOutside={false}
      withCloseButton={false}
      centered
    >
      <Text ta={"center"}>
        A subscription was purchased on another platform. You can manage your
        subscription there
      </Text>
      <Group mt="md" ta={'center'} justify="center">
        <Button onClick={() => navigate("/billing")}>
          Manage Subscription
        </Button>
      </Group>
    </Modal>
  );
};
export default ManageSubscriptionDialog;
